export var DictOrders = [
  { id: "46", value: "Annonciades", alternatives: [] },
  { id: "24", value: "Antonines", alternatives: ["antonins"] },
  {
    id: "47",
    value: "Augustinian Canons",
    alternatives: [
      "augustins",
      "augustinians",
      "canons regular",
      "chanoines reguliers",
      "canonesses regular",
    ],
  },
  {
    id: "34",
    value: "Augustinian Friars",
    alternatives: [
      "augustins",
      "augustinians",
      "augustinian hermits",
      "austin friars",
    ],
  },
  { id: "35", value: "augustinian Recollects", alternatives: [] },
  {
    id: "50",
    value: "Barnabites",
    alternatives: [],
  },
  {
    id: "51",
    value: "Bartholomites",
    alternatives: [],
  },
  {
    id: "52",
    value: "Basilians",
    alternatives: [],
  },
  {
    id: "3",
    value: "Benedictines",
    alternatives: ["benedictine", "bénédictins", "bénédictines"],
  },
  {
    id: "65",
    value: "Brothers Hospitallers of St. John of God",
    alternatives: [],
  },
  {
    id: "57",
    value: "Calasantins",
    alternatives: [],
  },
  {
    id: "61",
    value: "Canons Regular of the Holy Sepulchre",
    alternatives: [],
  },
  {
    id: "62",
    value: "Canons Regular of the Penitence of the Blessed Martyrs",
    alternatives: [],
  },
  {
    id: "5",
    value: "Camaldolese",
    alternatives: ["camalduls", "camaldules"],
  },
  { id: "31", value: "Capuchins", alternatives: ["coletans", "colletines"] },
  { id: "33", value: "Carmelites", alternatives: ["carmélites", "carmes"] },
  {
    id: "48",
    value: "Crosiers",
    alternatives: [
      "crutched friars",
      "brothers of the holy cross",
      "fratres cruciferi",
      "chanoines",
      "reguliers de la Sainte-Croix",
    ],
  },
  {
    id: "12",
    value: "Carthusians",
    alternatives: ["chartreux", "certosini"],
  },
  {
    id: "10",
    value: "Celestines",
    alternatives: ["célestins", "celestini", "cölestiner"],
  },
  { id: "1", value: "Celtic and Anglo-Saxon", alternatives: [] },
  {
    id: "8",
    value: "Chalais Order",
    alternatives: ["chalaisienne", "chalaisien"],
  },
  {
    id: "84",
    value: "Christian Brothers",
    alternatives: [],
  },
  {
    id: "77",
    value: "Christian Knights",
    alternatives: [],
  },
  {
    id: "15",
    value: "Cistercians",
    alternatives: ["cisterciens", "cisterciennes"],
  },
  {
    id: "58",
    value: "Claretians",
    alternatives: [],
  },
  { id: "4", value: "Cluniac Benedictines", alternatives: ["cluniac"] },
  { id: "30", value: "Colletines", alternatives: [] },
  { id: "43", value: "columbanus monks", alternatives: [] },
  { id: "42", value: "conceptionists", alternatives: [] },
  {
    id: "60",
    value: "Congregation of St. Michael the Archangel ",
    alternatives: [],
  },
  { id: "36", value: "discalced Augustinians", alternatives: [] },
  {
    id: "49",
    value: "Discalced Carmelites",
    alternatives: ["carmes déchaux"],
  },
  {
    id: "88",
    value: "Divine Word Missionaries",
    alternatives: [],
  },
  {
    id: "27",
    value: "Dominicans",
    alternatives: ["dominican", "jacobins", "jacobin", "dominicains"],
  },
  { id: "2", value: "early medieval", alternatives: [] },
  { id: "16", value: "Feuillants", alternatives: [] },
  {
    id: "9",
    value: "Fontevraud Order",
    alternatives: ["fontevraud", "fontevrault"],
  },
  {
    id: "28",
    value: "Franciscans",
    alternatives: ["mineurs", "franciscains", "franciscaines", "clarisses"],
  },
  {
    id: "85",
    value: "Fratres Consolati",
    alternatives: [],
  },
  {
    id: "66",
    value: "Conventual Franciscans",
    alternatives: [],
  },
  { id: "11", value: "Grandmontines", alternatives: [] },
  { id: "25", value: "Hermits of St. William", alternatives: [] },
  { id: "40", value: "hieronymites", alternatives: [] },
  { id: "18", value: "Hospitallers", alternatives: [] },
  { id: "21", value: "Hospitallers of the Holy Spirit", alternatives: [] },
  {
    id: "32",
    value: "Humiliati",
    alternatives: ["humiliés", "umiliati", "umiliate"],
  },
  {
    id: "54",
    value: "Hyberns",
    alternatives: [],
  },
  {
    id: "55",
    value: "Ivanites",
    alternatives: [],
  },
  {
    id: "56",
    value: "Jesuits",
    alternatives: [],
  },
  {
    id: "76",
    value: "Knights of the Cross with the Red Star",
    alternatives: [],
  },
  {
    id: "7",
    value: "La Chaise-Dieu Benedictines",
    alternatives: ["casadéens", "casadéen"],
  },
  {
    id: "80",
    value: "La Salette Missionaries",
    alternatives: [],
  },
  {
    id: "71",
    value: "Lazarists (Vincentians)",
    alternatives: [],
  },
  {
    id: "63",
    value: "Marian Fathers",
    alternatives: [],
  },
  {
    id: "64",
    value: "Marianists",
    alternatives: [],
  },
  { id: "37", value: "mercedarians", alternatives: [] },
  { id: "41", value: "minims", alternatives: ["minimes"] },
  {
    id: "67",
    value: "Oblates",
    alternatives: [],
  },
  { id: "14", value: "Olivetans", alternatives: ["olivétains"] },
  {
    id: "68",
    value: "Oratorians",
    alternatives: [],
  },
  { id: "22", value: "Order of Saint Lazarus", alternatives: [] },
  {
    id: "83",
    value: "Order of St. Stanislav",
    alternatives: [],
  },
  {
    id: "78",
    value: "Order of the Holy Spirit",
    alternatives: [],
  },
  {
    id: "69",
    value: "Pallottines",
    alternatives: [],
  },
  {
    id: "70",
    value: "Passionists",
    alternatives: [],
  },
  {
    id: "72",
    value: "Pauline Fathers",
    alternatives: [],
  },
  {
    id: "73",
    value: "Petrins",
    alternatives: [],
  },
  {
    id: "74",
    value: "Piarists",
    alternatives: [],
  },
  { id: "29", value: "Poor Clares", alternatives: ["clarisses"] },
  {
    id: "23",
    value: "Praemonstratensians",
    alternatives: ["prémontrés", "norbertines"],
  },
  {
    id: "59",
    value: "Priests of the Sacred Heart of Jesus",
    alternatives: [],
  },
  {
    id: "75",
    value: "Redemptorists",
    alternatives: [],
  },
  {
    id: "53",
    value: "Sacramentinos",
    alternatives: [],
  },
  {
    id: "82",
    value: "Sacred Heart Society",
    alternatives: [],
  },
  {
    id: "45",
    value: "Savigniac Order",
    alternatives: ["savigniens", "savigniens", "savigniennes"],
  },
  {
    id: "79",
    value: "Salesians",
    alternatives: [],
  },
  {
    id: "81",
    value: "Salvatorians",
    alternatives: [],
  },
  { id: "38", value: "servites", alternatives: [] },
  { id: "39", value: "sisters of Saint Andrew", alternatives: [] },
  { id: "13", value: "Sylvestrines", alternatives: ["silvestrins"] },
  { id: "19", value: "Templars", alternatives: ["templiers"] },
  {
    id: "20",
    value: "Teutonic Knights",
    alternatives: [
      "teutonique",
      "deutscher",
      "ritterorden",
      "deutschritter-orden",
    ],
  },
  {
    id: "86",
    value: "Theatines",
    alternatives: [],
  },
  {
    id: "17",
    value: "Trappists",
    alternatives: ["trappistes", "trappistines"],
  },
  {
    id: "87",
    value: "Trinitarians",
    alternatives: [],
  },
  { id: "26", value: "Trinitarians", alternatives: ["trinitaires"] },
  {
    id: "44",
    value: "Valliscaulians",
    alternatives: ["valliscauliens", "valliscauliens"],
  },
  { id: "6", value: "Vallombrosians", alternatives: ["vallombrosains"] },
  { id: "100", value: "other", alternatives: [] },
  { id: "0", value: "unknown", alternatives: [""] },
];
